import { useSDK } from "@sdk";
import { iAppFeatureRequest } from "@sdk/app-feature-requests/app-feature-requests-model";
import { Alert, Segmented, Tag } from "antd";
import _ from "lodash";
import { useMemo } from "react";
import { useSimpleState } from "utils/hooks/use-simple-state";
import { useUrlState } from "utils/hooks/use-url-state";
import { FeatureViewerPublicModal } from "../feature-viewer-modal/feature-viewer-basic-modal";
import { ReleaseNotes } from "../release-notes";
import "./road-map.scss";

const segments = [
  {
    value: "ROAD_MAP",
    label: (
      <div>
        <i className="ri-map-2-line"></i> Road map
      </div>
    ),
  },
  {
    value: "RELEASE_NOTES",
    label: (
      <div>
        <i className="ri-sticky-note-line"></i> Release Notes
      </div>
    ),
  },
];

const RoadMapPublicPageLegacy = () => {
  const { data: roadMapFeatures, reload } = useSDK(
    (SDK) => SDK.appFeatureRequests.getAll(),
    [],
  );

  const columnMap = useMemo(() => {
    const groupedFeatures = _.groupBy(roadMapFeatures || [], "status");
    return ["In Backlog", "Selected for Build", "In Build", "Released"].map(
      (status) => ({
        title: status,
        tickets: groupedFeatures[status] || [],
      }),
    );
  }, [roadMapFeatures]);

  const [activeTab, setActiveTab] = useUrlState<"ROAD_MAP" | "RELEASE_NOTES">(
    "activeTab",
    "ROAD_MAP",
  );

  const [featureViewerModalState, setFeatureViewerModal] = useSimpleState({
    visibility: false,
    feature: undefined as iAppFeatureRequest | undefined,
  });

  return (
    <div className="bg-white">
      <div className="flex justify-center items-center flex-col">
        <img
          src="/cc-assets/logo.png"
          style={{ width: "5rem" }}
          alt="ClickConnector"
        />
        <div className="text-2xl font-bold">
          ClickConnector{" "}
          {activeTab === "ROAD_MAP" ? "Road Map" : "Release Notes"}
        </div>
      </div>

      <div>
        <div className="view-selector flex flex-row justify-center items-center w-full mb-8">
          <Segmented
            options={segments}
            value={activeTab}
            onChange={(e) => setActiveTab((e as any).toString())}
          />
        </div>
        {activeTab === "ROAD_MAP" && (
          <>
            <Alert
              showIcon
              message="The roadmap is based on user requests. The product team has a separate product board for user comments, improvement suggestions, bugs, and R&D tasks."
              className="mb-4 max-w-3xl m-auto"
            />
            <div className="road-map-container flex flex-row justify-center gap-4 mt-8">
              {columnMap.map((column, i) => (
                <div
                  className="bg-gray-100 dark:bg-gray-900 rounded-lg p-4 flex flex-col"
                  key={`${column.title}-${i}`}
                  style={{ width: 300, minHeight: 300 }}
                >
                  <div className="font-bold p-2 flex flex-col justify-center items-center">
                    {column.title}
                  </div>
                  <div className="flex flex-col gap-4">
                    {column.tickets.map((item, i) => (
                      <div
                        key={`exploring-${i}`}
                        className="bg-white dark:bg-black p-4 rounded-lg cursor-pointer shadow-xs hover:shadow-lg"
                        onClick={() => {
                          setFeatureViewerModal({
                            visibility: true,
                            feature: item,
                          });
                        }}
                      >
                        <div className="font-bold">{item.title}</div>
                        <div
                          className="text-gray-600"
                          dangerouslySetInnerHTML={{
                            __html: item.shortDescription,
                          }}
                        />
                        <div className="text-gray-600" />
                        <div className="">
                          <Tag className="font-bold">
                            Category: {item.category || "Other"}
                          </Tag>{" "}
                          {item.tags.map((tag, index) => (
                            <Tag key={index.toString()}>{tag}</Tag>
                          ))}
                        </div>
                        <div className="flex flex-col justify-center items-center">
                          {/* {Boolean(item.comments.length) && (
                      <Badge
                        count={item.comments.length || 0}
                        color="blue"
                        showZero
                        offset={[5, 0]}
                      >
                        <i className="ri-question-answer-line"></i>
                      </Badge>
                    )} */}
                        </div>
                        {/* <div className="flex flex-row gap-4">
                  <div className="flex flex-row justify-center items-center">
                    <i className="ri-arrow-up-s-line"></i> {t.votes.length}
                  </div>
                  <div className="flex flex-row justify-center items-center">
                    <i className="ri-question-answer-line"></i>{" "}
                    {t.comments.length}
                  </div>
                </div> */}
                      </div>
                    ))}
                    {column.tickets.length === 0 && (
                      <div className="text-center text-gray-600">
                        No Active Items in This Column
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {activeTab === "RELEASE_NOTES" && (
          <div className="max-w-6xl mx-auto border rounded-lg border-gray-200 p-4 py-8 mt-4">
            <ReleaseNotes />
          </div>
        )}
      </div>

      <FeatureViewerPublicModal
        visible={featureViewerModalState.visibility}
        onChangeVisibility={(visibility) =>
          setFeatureViewerModal({ visibility: false })
        }
        feature={featureViewerModalState.feature}
      />
    </div>
  );
};

const RoadMapPublicPage = () => {
  return <div>Not Found</div>;
};

export default RoadMapPublicPage;
